const PREFIX = 'consent-bootstrap:'
const recordedMarks = new Set<string>()

export function markConsentTiming(name: string, once = false): void {
  if (!import.meta.client || typeof performance.mark !== 'function') {
    return
  }

  const markName = `${PREFIX}${name}`
  if (once && recordedMarks.has(markName)) {
    return
  }

  recordedMarks.add(markName)
  performance.mark(markName)
}

export function measureConsentTiming(
  name: string,
  startMark: string,
  endMark: string
): void {
  if (!import.meta.client || typeof performance.measure !== 'function') {
    return
  }

  const startName = `${PREFIX}${startMark}`
  const endName = `${PREFIX}${endMark}`
  if (
    performance.getEntriesByName(startName, 'mark').length === 0 ||
    performance.getEntriesByName(endName, 'mark').length === 0
  ) {
    return
  }

  performance.measure(`${PREFIX}${name}`, startName, endName)
}

export function resetConsentTimingForTests(): void {
  recordedMarks.clear()
}
